import { ApiServiceType, API_PREFIX } from '@cbridge-packages/api-base';

/**
 * Builds the CLP WebSocket URL from `VITE_API_BASE_URL`:
 * - `%PREFIX%` → `clp` (nginx routes `/clp` to the Client Proxy service, LB-3911)
 * - `http`/`https` → `ws`/`wss`
 * - suffix `/prices` (endpoint `GET /api/v1/prices`, LB-A-1156)
 * - `clientId`, when provided, is appended as a query param; nginx translates it into the
 *   upstream `X-Client-Id` header via `proxy_set_header X-Client-Id $arg_clientId;`.
 *   (The browser WebSocket API cannot set custom headers on the upgrade — hence the query param.)
 */
export const resolveClpWsUrl = (clientId?: string): string => {
  const base = String(import.meta.env['VITE_API_BASE_URL'] ?? '');
  const withPrefix = base.replace(API_PREFIX, ApiServiceType.Clp);
  const url = new URL(`${withPrefix}/prices`, window.location.origin);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  if (clientId) {
    url.searchParams.set('clientId', clientId);
  }
  return url.toString();
};
